'use client';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
export const useCopyAddress = () => {
    return useCallback(() => {
        toast.success('Address was copied to clipboard.');
    }, []);
};
